import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import API from "../../Services/API";
import EmptyPic from "../../Assets/Images/emptypic.png";
import Header from "../../Layouts/Header";
import Loading from "../../Layouts/Loading";
import Toast from "../../Components/Toast";

const EditProfile = () => {
    const [avatar, setAvatar] = useState(null);
    const [pic, setPic] = useState(EmptyPic);
    const [surname, setSurname] = useState("");
    const [name, setName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [file, setFile] = useState(null);
    const [buttonStatus, setButtonStatus] = useState(false);
    const [buttonText, setButtonText] = useState("ثبت تغییرات");
    const [loading, setLoading] = useState(true);

    const [states, setStates] = React.useState([]);
    const [stateId, setStateId] = React.useState(0);
    const [cities, setCities] = React.useState([]);
    const [cityID, setCityId] = React.useState(0);
    const [areas, setAreas] = React.useState([]);
    const [areaId, setAreaId] = React.useState(0);

    useEffect(() => {
        API.getUserInfo()
            .then((response) => {
                const user = response.data.user;
                setSurname(user.surname || "");
                setName(user.name || "");
                setNationalCode(user.national_code || "");
                setPhone(user.username || "");
                setEmail(user.email || "");
                setStateId(user.state || 0);
                setCityId(user.city || 0);
                setAreaId(user.area || 0);
                setPic(user.avatar || EmptyPic);
                API.getStates()
                    .then((response) => {
                        setStates(response.data);


                    })
                if(user.state) {
                    onGetCities(user.state)
                }
                if (user.city){
                    onGetAreas(user.city)
                }
                setLoading(false)
            })
            .catch(() => {
                toast.error("بارگذاری اطلاعات کاربر موفق نبود");
            });
    }, []);

    const onFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            setPic(reader.result);
            setFile(file);
        };
        reader.readAsDataURL(file);
    };

    const onGetCities = (stateID) => {
        setLoading(true)
        const params = {
            state_id : stateID
        }
        API.getCities(params)
            .then((response) => {
                setCities(response.data);
                setLoading(false)

            })
    }

    const onGetAreas = (stateID) => {
        setLoading(true)
        const params = {
            city_id : stateID
        }
        API.getAreas(params)
            .then((response) => {
                setAreas(response.data);
                setLoading(false)

            })
    }

    const onInputChange = (setter) => (e) => {
        setter(e.target.value);
    };

    const onSubmit = () => {
        if (buttonStatus) return; // جلوگیری از کلیک مکرر

        if(areaId < 1) {
            toast.error('لطفا منطقه شهری خود را مشخص کنید');
            return false;
        }

        setButtonText("");
        setLoading(true);
        setButtonStatus(true);

        const formData = new FormData();
        if (file) formData.append("avatar", file);
        formData.append("surname", surname);
        formData.append("name", name || "");
        formData.append("national_code", nationalCode || "");
        formData.append("phone", phone);
        if (email) formData.append("email", email);
        formData.append('province_id', stateId);
        formData.append('city_id', cityID);
        formData.append('area_id', areaId);
        formData.append("device_info", navigator.userAgent);

        API.updateProfile(formData)
            .then((response) => {
                toast.success(response.message);
            })
            .catch((error) => {
                toast.error(error.response?.data?.user_message || "خطا در بروزرسانی پروفایل");
            })
            .finally(() => {
                setButtonText("ثبت تغییرات");
                setLoading(false);
                setButtonStatus(false);
            });
    };

    return (
        <div className='container pt-5'>
            <Header title='  ویرایش پروفایل ' hasBack={true} />
            {
                loading && <Loading />
            }
            <Toast />
            <div className="edit-profile-container"
                 style={{maxWidth: 500, margin: "20px auto", fontFamily: "'Vazirmatn', sans-serif", direction: "rtl"}}>


                <div style={{textAlign: "center", marginBottom: 20}}>
                    <label htmlFor="avatarInput" style={{cursor: "pointer"}}>
                        <img
                            src={pic}
                            alt="تصویر پروفایل"
                            style={{
                                width: 120,
                                height: 120,
                                objectFit: "cover",
                                borderRadius: "50%",
                                border: "2px solid #4a90e2"
                            }}
                        />
                        <input type="file" id="avatarInput" onChange={onFileChange} style={{display: "none"}}
                               accept="image/*"/>
                        <div style={{marginTop: 10, color: "#666", fontSize: 14}}>انتخاب تصویر پروفایل جدید</div>
                    </label>

                </div>

                <div style={{marginBottom: 10}}>
                    <label>نام</label>
                    <input type="text" value={name} onChange={onInputChange(setName)} placeholder="نام"
                           style={inputStyle}/>
                </div>

                <div style={{marginBottom: 10}}>
                    <label>نام خانوادگی</label>
                    <input type="text" value={surname} onChange={onInputChange(setSurname)} placeholder="نام خانوادگی"
                           style={inputStyle}/>
                </div>

                <div style={{marginBottom: 10}}>
                    <label>شماره موبایل</label>
                    <input type="text" value={phone} disabled={true} placeholder="شماره موبایل"
                           style={inputStyle}/>
                </div>

                <div style={{marginBottom: 10}}>
                    <label>کد ملی</label>
                    <input type="number" value={nationalCode} onChange={onInputChange(setNationalCode)}
                           placeholder="کد ملی" style={inputStyle}/>
                </div>

                <div style={{marginBottom: 10}}>
                    <label>آدرس ایمیل</label>
                    <input type="email" value={email} onChange={onInputChange(setEmail)} placeholder="آدرس ایمیل"
                           style={inputStyle}/>
                </div>

                <div className="col-12 mt-4 border-top pt-3 ">
                    <div className="form-floating">
                        <select className="form-select" id="floatingSelect"
                                aria-label="Floating label select example"
                                onChange={(event) => {
                                    setStateId(event.target.value)
                                    onGetCities(event.target.value)
                                }}
                                value={stateId}

                        >
                            <option selected value={0}>انتخاب استان</option>
                            {
                                !loading && states.map(group => {
                                        return (
                                            <option value={group.id} key={group.id}>
                                                {group.name}
                                            </option>
                                        );
                                    }
                                )
                            }

                        </select>
                        <label htmlFor="floatingSelect" className="right-0">

                        </label>
                    </div>
                </div>


                <div className="col-12 mt-3 ">
                    <div className="form-floating">
                        <select className="form-select" id="floatingSelect"
                                aria-label="Floating label select example"
                                onChange={(event) => {
                                    setCityId(event.target.value)
                                    onGetAreas(event.target.value)
                                }}
                                value={cityID}

                        >
                            <option selected value={0}>انتخاب شهر</option>
                            {
                                !loading && cities.map(group => {
                                        return (
                                            <option value={group.id} key={group.id}>
                                                {group.name}
                                            </option>
                                        );
                                    }
                                )
                            }

                        </select>
                        <label htmlFor="floatingSelect" className="right-0">

                        </label>
                    </div>
                </div>


                <div className="col-12 mt-3 ">
                    <div className="form-floating">
                        <select className="form-select" id="floatingSelect"
                                aria-label="Floating label select example"
                                onChange={(event) => {
                                    setAreaId(event.target.value)

                                }}
                                value={areaId}
                        >
                            <option selected value={0}>انتخاب منطقه شهری</option>
                            {
                                !loading && areas.map(group => {
                                        return (
                                            <option value={group.id} key={group.id}>
                                                {group.name}
                                            </option>
                                        );
                                    }
                                )
                            }

                        </select>
                        <label htmlFor="floatingSelect" className="right-0">

                        </label>
                    </div>
                </div>


                <button
                    onClick={onSubmit}
                    disabled={buttonStatus}
                    className='mt-5'
                    style={{
                        width: "100%",
                        padding: "10px 0",
                        backgroundColor: buttonStatus ? "#a1c4fd" : "#4a90e2",
                        color: "#fff",
                        fontWeight: "bold",
                        borderRadius: 6,
                        border: "none",
                        cursor: buttonStatus ? "not-allowed" : "pointer",
                        transition: "background-color 0.3s ease"
                    }}
                >
                    {loading ? <span className="spinner-border spinner-border-sm" role="status"
                                     aria-hidden="true"></span> : null}
                    &nbsp;{buttonText}
                </button>
            </div>
        </div>
    );
};

const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    borderRadius: 5,
    border: "1px solid #ccc",
    fontSize: 15,
    outline: "none",
    boxSizing: "border-box"
};

export default EditProfile;
